module.exports = __webpack_public_path__ + "static/img/xcc.918df645.jpg";